module.exports = __webpack_public_path__ + "img/Q1.fc994b13.png";